import {
  FETCH_DOCUMENTS_VERSION_REQUEST,
  FETCH_DOCUMENTS_VERSION_SUCCESS,
  FETCH_DOCUMENTS_VERSION_FALUIRE,
} from './documentVersionHostoryTypes'

const initialState = {
  loading: false,
  documentVersionInfo: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DOCUMENTS_VERSION_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DOCUMENTS_VERSION_SUCCESS : return {
      ...state,
      documentVersionInfo: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DOCUMENTS_VERSION_FALUIRE : return {
      ...state,
      loading: false,
      documentVersionInfo: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
